
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/DMCA",
      function () {
        return require("private-next-pages/DMCA.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/DMCA"])
      });
    }
  